import React from 'react';



type Props = {
  className?: string;
}
export const SideWrongFirstVector: React.FC<Props> = ({ className }) => {
  return (
    <svg className = { className } width = '154' height = '116' viewBox = '0 0 154 116' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'>
      <rect stroke = '#DBB4B6' strokeDasharray = '3 3' x = '0.5' y = '12.5' width = '153' height = '103' />
      <rect fill = '#FBFBFB' stroke = '#CCD2DA' x = '9.5' y = '26.5' width = '135' height = '80' />
      <rect fill = '#F4F4F4' x = '13' y = '30' width = '128' height = '3' />
      <rect fill = '#F4F4F4' x = '13' y = '44' width = '128' height = '3' />
      <rect fill = '#F4F4F4' x = '13' y = '58' width = '128' height = '3' />
      <rect fill = '#F4F4F4' x = '13' y = '72' width = '128' height = '3' />
      <rect fill = '#F4F4F4' x = '13' y = '86' width = '128' height = '3' />
      <rect fill = '#F4F4F4' x = '13' y = '100' width = '128' height = '3' />
      <rect fill = '#F4F4F4' x = '13' y = '37' width = '128' height = '3' />
      <rect fill = '#F4F4F4' x = '13' y = '51' width = '128' height = '3' />
      <rect fill = '#F4F4F4' x = '13' y = '65' width = '128' height = '3' />
      <rect fill = '#F4F4F4' x = '13' y = '79' width = '128' height = '3' />
      <rect fill = '#F4F4F4' x = '13' y = '93' width = '128' height = '3' />
      <rect stroke = '#CCD2DA' strokeDasharray = '5 3' x = '76.5' y = '34.5' width = '1' height = '63' />
      <rect stroke = '#CCD2DA' strokeDasharray = '5 3' x = '123.5' y = '65.5' width = '1' height = '93' transform = 'rotate(90 123.5 65.5)' />
      <rect fill = '#FBFBFB' width = '34' height = '46' transform = 'translate(19 52)' />
      <path fill = '#002F6C' d = 'M42.7692 57H29.2308C26.8954 57 25 58.8327 25 61.0909V88.9091C25 91.1673 26.8954 93 29.2308 93H42.7692C45.1046 93 47 91.1673 47 88.9091V61.0909C47 58.8327 45.1046 57 42.7692 57ZM36 91.3636C34.5954 91.3636 33.4615 90.2673 33.4615 88.9091C33.4615 87.5509 34.5954 86.4545 36 86.4545C37.4046 86.4545 38.5385 87.5509 38.5385 88.9091C38.5385 90.2673 37.4046 91.3636 36 91.3636ZM43.6154 84.8182H28.3846V61.9091H43.6154V84.8182Z' />
      <rect fill = '#002F6C' x = '25' y = '57' width = '14' height = '14' rx = '5' />
      <circle fill = '#FBFBFB' cx = '30' cy = '62' r = '2' />
      <circle fill = '#85A4CD' cx = '29.5' cy = '66.5' r = '1.5' />
      <circle fill = '#FBFBFB' cx = '34.5' cy = '61.5' r = '1.5' />
      <rect fill = '#FBFBFB' width = '40' height = '24' transform = 'translate(57)' />
      <path fill = '#BF1D26' stroke = '#BF1D26' strokeWidth = '0.2' d = 'M84.1416 6.41016L84.0703 6.48047L78.5508 12L84.0703 17.5195L84.1416 17.5898L82.5898 19.1416L82.5195 19.0703L77 13.5508L71.4805 19.0703L71.4102 19.1416L69.8584 17.5898L69.9297 17.5195L75.4492 12L69.9297 6.48047L69.8584 6.41016L71.4102 4.8584L71.4805 4.92969L77 10.4492L82.5195 4.92969L82.5898 4.8584L84.1416 6.41016Z' />
    </svg>
  );
};